import React from 'react';

import Typography from 'components/typography/typography';

interface PairValueInterface {
  Title: string;
  Value: string;
}

const Pairtext: React.FC<PairValueInterface> = ({ Title, Value }) => {
  return (
    <div className="flex flex-wrap flex-col gap-2">
      <Typography
        as="p"
        variant="body-medium-bold"
        className="text-gray400/60 text-xs font-semibold"
      >
        {Title}
      </Typography>
      <Typography
        as="p"
        variant="body-medium-bold"
        className="font-normal text-gray800/80 text-sm"
      >
        {Value}
      </Typography>
    </div>
  );
};

export default Pairtext;
